import React from 'react';
import { useDarkMode } from '../darkmode/DarkModeContext';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Section = () => {
  const { isDarkMode } = useDarkMode();
  const navigate = useNavigate(); // Initialize useNavigate

  // Styling untuk dark mode
  const gradientStyle = isDarkMode 
    ? 'bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900' 
    : 'bg-gradient-to-r from-[#1E9B4C] to-[#1E9B4C]';

  const titleStyle = isDarkMode ? 'text-white' : 'text-white'; 
  const descriptionStyle = isDarkMode ? 'text-gray-300' : 'text-white'; 
  const buttonStyle = isDarkMode 
    ? 'bg-[#1E9B4C] text-white hover:bg-[#1E9B4C]' 
    : 'bg-[#dfe4e0ff] text-[#1E9B4C] hover:bg-gray-100'; 

  // const statsNumberStyle = isDarkMode ? 'text-white' : 'text-[#1E9B4C]'; 
  // const statsLabelStyle = isDarkMode ? 'text-gray-400' : 'text-[#1E9B4C]';

  // Function to handle button click and navigate to /produk
  const handleSubscriptionClick = () => {
    navigate('/produk'); // Navigate to /produk when button is clicked
  };

  return (
    <section className={`py-16 ${gradientStyle}`}>
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className={`text-4xl font-bold mb-6 ${titleStyle}`}>
          Rasakan Pengalaman Nonton TV Tanpa Gangguan
        </h2>
        <p className={`text-xl mb-8 ${descriptionStyle}`}>
          Bergabunglah dengan ribuan pelanggan yang telah menikmati layanan IPTV berkualitas tinggi, 
          didukung oleh teknologi internet super cepat dari telnet home kami.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <button 
            onClick={handleSubscriptionClick} // Call the handleSubscriptionClick function
            className={`${buttonStyle} px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:transform hover:scale-105 shadow-lg`}
            style={isDarkMode ? { backgroundColor: '#1E9B4C' } : {}}
          >
            Langganan Sekarang
          </button>
        </div>
      </div>
    </section>
  );
};

export default Section;